import { useWindowWidth } from '@vista-digital/occ-ui/src/lib/hooks/use-window-width'
import { useEffect } from 'react'
import { navigationMenuStore } from '@/features/layout/stores/navigationMenu.store'

export const useMobileNav = () => {
    const { hideNavMenu, toggleNavMenu } = navigationMenuStore
    const isMobileView = useWindowWidth() < 992

    useEffect(() => hideNavMenu(), [isMobileView])

    const toggleMobileNav = () => isMobileView && toggleNavMenu()

    return { toggleMobileNav }
}
